import { useMantineTheme } from "@mantine/core";
import type { MantineThemeOther } from "@mantine/core";

export const useColors = (): MantineThemeOther["colors"] => {
  return useMantineTheme().other.colors;
};
